import { GeoEventRegion } from 'features/geoEvents/geoEventRegion.types';
import { NotificationSettingTypes } from 'features/notifications/notifications.constants';

export type NotificationSettingsKeys = keyof typeof NotificationSettingTypes;

export type NotificationOption =
  (typeof NotificationSettingTypes)[NotificationSettingsKeys];

export type NotificationRegion = {
  id: number;
  displayName: string;
  state: string;
  stateDisplayName: string;
  isReporterCoveredForFire: boolean;
};

export type NotificationSetting = {
  region: NotificationRegion;
  setting: NotificationOption;
};

export type NotificationSettingForPut = {
  region: NotificationRegion | GeoEventRegion;
  setting: NotificationOption;
};

export type NotificationSettingAPI = {
  data: NotificationSetting[];
};

export type RegionSection = {
  title: string;
  regionSettings: NotificationSetting[];
  isReporterCoveredForFire: boolean;
};

export enum NotificationType {
  Normal = 'normal',
  Silent = 'silent',
  Critical = 'critical',
}
